import React, { useEffect, useState } from "react";

import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import i18n from "../i18n";
import LoaderComponent from "./Loader.component";
import FaCheckCircle from "../assets/icons/faCheckCircle.svg";
import FaHome from "../assets/icons/faHome.svg";
import apiService from "../services/api";

type UnsubscribeState = "loading" | "success" | "error";

const UnsubscribeComponent = () => {
  const [status, setStatus] = useState<UnsubscribeState>("loading");
  const { t } = i18n;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("t");

    if (!token) {
      setStatus("error");
      return;
    }

    const unsubscribeEmail = async () => {
      try {
        await apiService.unsubscribe(token);
        setStatus("success");
      } catch (error) {
        console.error("Failed to unsubscribe:", error);
        setStatus("error");
      }
    };

    unsubscribeEmail();
  }, []);

  if (status === "loading") {
    return <LoaderComponent />;
  }

  if (status === "success") {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center position-absolute h-100 w-100 gap-4">
        <img alt={t(`unsubscribe`)} src={FaCheckCircle} />

        <NavLink className="mt-2" to={`${getUrlLangPrefix()}/`}>
          <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2">
            <img alt={t(`home`)} src={FaHome} />
            <span>{t("go_to_homepage")}</span>
          </Button>
        </NavLink>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center position-absolute h-100 w-100 gap-4">
        <FontAwesomeIcon icon={faBug} size="4x" />
        {t("_error_message")}

        <NavLink className="mt-2" to={`${getUrlLangPrefix()}/`}>
          <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2">
            <img alt={t(`home`)} src={FaHome} />
            <span>{t("go_to_homepage")}</span>
          </Button>
        </NavLink>
      </div>
    );
  }

  return null;
};

export default UnsubscribeComponent;
